import React from 'react';
import styled from 'styled-components';
import { SixteenNineAspectRatioPlaceholder } from '../../../components/Layout';
import WhiteLabel from '../../../filters/WhiteLabel';
import apiClient from '../../../services/apiClient';
import { useOrg } from '../../org';

const LargeLogo = styled.img`
  max-width: 70%;
  height: auto;
  max-height: 40%;
`;

const WhiteLabelLogoPlaceholder = () => {
  return (
    <SixteenNineAspectRatioPlaceholder>
      <LargeLogo alt={WhiteLabel.name} src={WhiteLabel.logoSrc} />
    </SixteenNineAspectRatioPlaceholder>
  );
};

const OrgLogoPlaceholder = ({ name, logoSrc }: { name: string; logoSrc: string }) => {
  const apiUrl = apiClient.getConfig().baseURL;
  const orgLogoSrc = `${apiUrl}/v1/images/org/${logoSrc}`;

  return (
    <SixteenNineAspectRatioPlaceholder>
      <LargeLogo alt={name} src={orgLogoSrc} />
    </SixteenNineAspectRatioPlaceholder>
  );
};

export default function TrainingPosterPlaceholder({ ownerName }: { ownerName?: string }) {
  const { org } = useOrg();

  const isOrgOwned = ownerName && ownerName != WhiteLabel.name;
  const hasLogo = org && org.logo;
  const useOrgLogo = WhiteLabel.isGrid() && isOrgOwned && hasLogo;

  return useOrgLogo ? <OrgLogoPlaceholder name={ownerName} logoSrc={org.logo || ''} /> : <WhiteLabelLogoPlaceholder />;
}
